import React, {Component} from 'react';
import {getTranslate, getActiveLanguage} from "react-localize-redux";
import {connect} from "react-redux";
import PropTypes from 'prop-types';

/**
 * import fonts
 */
import FaQuestionCircle from "react-icons/lib/fa/question-circle";
import FaInfoCircle from 'react-icons/lib/fa/info-circle';

/**
 * import actins
 */
import * as actions from "../../actions";

/**
* import components
*/
import PrevNext from '../PrevNext';
import FormInput from '../forms/FormInput';
import FormInputField from '../forms/FormInputField';
import MixForm from '../forms/MixForm';
import ImageContainer from '../image-handler/ImageContainer';
import wtImage from '../../assets/images/wt_3.png';
import {cleanTextInput} from "../../utils/helpers";

class StepThree extends Component {

    constructor(props) {
        super(props);
        this.state = {
            withoutOverflow: false,
            tissueDispenser: false,
            position:        [
                {value: "left", name: "links"},
                {value: "right", name: "rechts"},
                {value: "bellow", name: "vorne"},
                {value: "above", name: "hinten"},
            ],
        }
    }

    render() {
        return (
            <div className="wt-step-2 step-content">
                <div className='row'>
                    <h5 className='col s12' >
                        {this.props.translate('WT.stepThree.menu.title')}
                    </h5>
                </div>
                <div className="row">
                    <div className="col s11">
                        <FormInput
                            type="checkbox"
                            name="WT.MISSING_KTSV_checkbox"
                            value={this.props.wt.MISSING_KTSV_checkbox.CurrentValue}
                            checked={this.props.wt.MISSING_KTSV_checkbox.CurrentValue === '1'}
                            disabled={this.props.wt.KTSV.CurrentValue === '0'}
                            labelPosition="inline"
                            labelName={this.props.translate('WT.stepThree.form.tissueDispensers')}
                            divClass={"col s12"} />
                    </div>
                    <div className='col s1 right-align'>
                        <FaQuestionCircle className='right-align' style={{fontSize: '20px'}} />
                    </div>
                    <div className="col s12">
                        <div className="col m4">
                            <FormInput
                                type="select"
                                options={this.props.wt.KTS.Values.Value}
                                name="WT.KTS"
                                value={this.props.wt.KTS.CurrentValue}
                                checked={this.props.wt.KTS.CurrentValue}
                                disabled={this.props.wt.MISSING_KTSV_checkbox.CurrentValue === '0'}
                                divClass="col s12" />
                            <FormInput
                                type='text'
                                name='WT.KTS_T'
                                value={this.props.wt.KTS.CurrentValue === '99' ? cleanTextInput(this.props.wt.KTS_T.CurrentValue) : ''}
                                disabled={this.props.wt.KTS.CurrentValue !== '99'}
                                placeholder={this.props.translate('WT.stepThree.form.text_field.placeholder')}
                                fieldStyle={{width: '100%', padding: 0}}
                                divClass='col s12' />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col m6">
                        <FormInput
                            type="checkbox"
                            name="WT.UL_inverter"
                            value={this.props.wt.UL_inverter.CurrentValue}
                            isChecked={this.props.wt.UL_inverter.CurrentValue}
                            labelPosition="inline"
                            labelName={this.props.translate('WT.stepThree.form.withoutOverflow')}
                            divClass={"col s12"} />
                    </div>
                </div>
                <div className='col s12 center-align'>
                    <ImageContainer
                        image={this.props.image.Image ? this.props.image.Image : ''}
                        name='wt'
                        loadingImage={true}
                        height= '100%'/>
                </div>
            </div>
        );
    }

}

StepThree.propTypes = {
    translate: PropTypes.func,
}

function mapStateToProps({locale, wt, image}) {
    return {
        translate: getTranslate(locale),
        wt,
        image,
    }
}

export default connect(mapStateToProps, actions)(StepThree);



// WEBPACK FOOTER //
// ./src/components/wt-steps/StepThree.js